import React from "react";
import "./styles.scss";
import Channels from "./Channels";
import Chat from "./Chat";
import { Sendbird } from "../../../api/sendbird";
import FullPageSpinner from "../../FullPageSpinner";
import _ from "lodash";
import SendNewMessage from "../shared/SendNewMessage";

const sendbird_client = new Sendbird();

export default class Inbox extends React.Component {
  state = {
    selectedChannel: null,
    channelsLister: null,
    channels: null,
    messagesLister: null,
    messages: null
  };
  componentDidMount = async () => {
    if (_.isNull(this.state.channels)) {
      this.reloadChannels();
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.messages !== this.state.messages &&
      this.messagesListReference
    ) {
      this.messagesListReference.current.scrollIntoView({ behavior: "smooth" });
    }
  }
  reloadChannels = async () => {
    this.setState({ channels: null, channelsLister: null });
    let channelsLister = await sendbird_client.listMyGroupChannelList();
    await this.setState({ channelsLister });
    this.loadMoreChannels();
  };
  onSelectChannel = async channel => {
    sendbird_client.sb.removeUserEventHandler("selected_channel_handler");
    var ChannelHandler = new sendbird_client.sb.ChannelHandler();
    ChannelHandler.onMessageReceived = (channel, message) => {
      let newMessages = [message, ...this.state.messages];
      this.setState({ messages: newMessages });
    };
    sendbird_client.sb.addChannelHandler(
      "selected_channel_handler",
      ChannelHandler
    );
    let lister = await sendbird_client.loadPreviouseMessages(channel);
    await this.setState({
      messagesLister: lister,
      selectedChannel: channel,
      messages: null
    });
  };
  loadMoreChannels = () =>
    new Promise((resolve, rejevt) => {
      this.state.channelsLister.next((channels, error) =>
        resolve(this.setState({ channels }))
      );
    });
  loadMoreMessages = () =>
    new Promise((resolve, reject) => {
      this.state.messagesLister.load((messages, error) =>
        resolve(this.setState({ messages: messages || [] }))
      );
    });
  onSubmitMessage = async (text, media) => {
    let newMessage = await sendbird_client.sendMessage(
      this.state.selectedChannel,
      text,
      media
    );
    let newMessages = [newMessage, ...this.state.messages];
    this.setState({ messages: newMessages });
    return true;
  };
  messagesEndRef = React.createRef();
  render() {
    return this.props.sb_connection ===
      sendbird_client.sb.ConnectionState.CLOSED ? (
      <div className="text-center">
        <div className="alert alert-warning">
          Something went wrong connecting
        </div>
        <button
          className="btn btn-sm btn-primary"
          onClick={this.props.initSbConnection}
        >
          Reconnect
        </button>
      </div>
    ) : this.props.sb_connection === sendbird_client.sb.ConnectionState.OPEN &&
      !_.isNull(this.state.channels) ? (
      <div id="inbox" className="row no-gutters">
        <div className="col-34">
          <div className="inbox-header d-flex justify-content-between mx-4">
            <h2>Inbox</h2>
            <SendNewMessage className="btn btn-sm btn-light">
              Send a message
            </SendNewMessage>
          </div>
          <Channels
            selectedChannel={this.state.selectedChannel}
            onSelectChannel={this.onSelectChannel}
            channels={this.state.channels}
            channelsLister={this.state.channelsLister}
          />
        </div>
        <div id="chat-section" className="col-66 pl-0">
          <Chat
            refMessages={this.messagesEndRef}
            selectedChannel={this.state.selectedChannel}
            onLoadMore={this.loadMoreMessages}
            messagesLister={this.state.messagesLister}
            messages={this.state.messages}
            onSubmitMessage={this.onSubmitMessage}
          />
        </div>
      </div>
    ) : (
      <FullPageSpinner
        status={sendbird_client.sb.getConnectionState()}
        meta={sendbird_client.sb.getConnectionState()}
      />
    );
  }
}
